import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  
  // 1. Check if the URL is part of the auth endpoints
  // This matches /api/v1/auth/login, /register, /forgot-password, etc.
  const isAuthEndpoint = req.url.includes('/api/v1/auth');

  // If it's an auth endpoint, pass the request exactly as it is (no token needed)
  if (isAuthEndpoint) {
    return next(req);
  }

  // 2. Retrieve the token from localStorage
  // Replace 'bwari_auth_token' with whatever key you used in your AuthService
  const token = localStorage.getItem('bwari_jwt_token');
  console.log('Retrieved token from localStorage:', token);
  
  let modifiedReq = req;

  // 3. If a token exists, clone the request and add the Authorization header
  if (token) {
    console.log('adding token to request headers');
    modifiedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  // 4. Send the request and handle potential 401 Unauthorized errors globally
  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // If the backend rejects the token (e.g., it expired)
      if (error.status === 401) {
        console.warn('Token expired or unauthorized. Redirecting to login.');
        localStorage.removeItem('bwari_auth_token'); // Clear the bad token
        router.navigate(['/login']); // Kick them back to the login screen
      }
      return throwError(() => error);
    })
  );
};